import React from 'react';
import { useParams } from 'react-router-dom';
import { Attachments, HasAccess } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const ItemAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  return (
    <HasAccess role={PERMISSIONS.items.attachment.read}>
      <Attachments
        entityId={id}
        hasAccessToWrite={hasAccess(PERMISSIONS.items.attachment.write)}
        hasAccessToDelete={hasAccess(PERMISSIONS.items.attachment.delete)}
        entityName={'ITEM'}
        service={'item'}
      />
    </HasAccess>
  );
});
